import { validateGasFeeResult } from "uniswap/src/features/gas/types";
import { isBridge, isClassic, isUniswapX, isAggregator } from "uniswap/src/features/transactions/swap/utils/routing";
import { isInterface } from "utilities/src/platform";
export function isValidSwapTxContext(swapTxContext) {
  return validateSwapTxContext(swapTxContext) !== void 0;
}
export var PermitMethod = /* @__PURE__ */ ((PermitMethod2) => {
  PermitMethod2["Transaction"] = "Transaction";
  PermitMethod2["TypedData"] = "TypedData";
  return PermitMethod2;
})(PermitMethod || {});
function validateClassicSwapTxContext(swapTxContext, gasFee) {
  const { trade, unsigned, permit, txRequests, includesDelegation } = swapTxContext;
  if (!trade) {
    return void 0;
  }
  const includesDelegationValue = includesDelegation ?? false;
  if (unsigned) {
    if (!isInterface || !permit || permit.method !== "TypedData" /* TypedData */) {
      return void 0;
    }
    return { ...swapTxContext, trade, gasFee, unsigned, txRequests: void 0, permit, includesDelegation: includesDelegationValue };
  }
  if (txRequests) {
    return { ...swapTxContext, trade, gasFee, unsigned, txRequests, permit: void 0, includesDelegation: includesDelegationValue };
  }
  return void 0;
}
function validateBridgeSwapTxContext(swapTxContext, gasFee) {
  const { trade, txRequests, includesDelegation } = swapTxContext;
  const includesDelegationValue = includesDelegation ?? false;
  if (!txRequests) {
    return void 0;
  }
  return { ...swapTxContext, trade, gasFee, txRequests, includesDelegation: includesDelegationValue };
}
function validateAggregatorSwapTxContext(swapTxContext, gasFee) {
  const { trade, unsigned, permit, txRequests, includesDelegation } = swapTxContext;
  if (!trade) {
    return void 0;
  }
  const includesDelegationValue = includesDelegation ?? false;
  if (unsigned) {
    if (!isInterface || !permit || permit.method !== "TypedData" /* TypedData */) {
      return void 0;
    }
    return { ...swapTxContext, trade, gasFee, unsigned, txRequests: void 0, permit, includesDelegation: includesDelegationValue };
  }
  if (txRequests) {
    return { ...swapTxContext, trade, gasFee, unsigned, txRequests, permit: void 0, includesDelegation: includesDelegationValue };
  }
  return void 0;
}
function validateUniswapXSwapTxContext(swapTxContext, gasFee) {
  const { trade, permit } = swapTxContext;
  if (!permit) {
    return void 0;
  }
  return { ...swapTxContext, trade, gasFee, permit, includesDelegation: false };
}
function validateSwapTxContext(swapTxContext) {
  if (!isSwapTx(swapTxContext)) {
    return void 0;
  }
  const gasFee = validateGasFeeResult(swapTxContext.gasFee);
  if (!gasFee) {
    return void 0;
  }
  if (!swapTxContext.trade) {
    return void 0;
  }
  if (isClassic(swapTxContext)) {
    return validateClassicSwapTxContext(swapTxContext, gasFee);
  }
  if (isBridge(swapTxContext)) {
    return validateBridgeSwapTxContext(swapTxContext, gasFee);
  }
  if (isAggregator(swapTxContext)) {
    return validateAggregatorSwapTxContext(swapTxContext, gasFee);
  }
  if (isUniswapX(swapTxContext)) {
    return validateUniswapXSwapTxContext(swapTxContext, gasFee);
  }
  return void 0;
}
function isSwapTx(swapTxContext) {
  return typeof swapTxContext === "object" && swapTxContext !== null && "trade" in swapTxContext && "routing" in swapTxContext;
}
